module.exports = __webpack_public_path__ + "img/logo-telesalud.9f5253f4.png";